
import { Button } from "@/components/ui/button";
import { Eye, Save } from "lucide-react";

interface FormActionsProps {
  onPreview: () => void;
  isSubmitting: boolean;
  hasCalculatedNutrition: boolean;
}

export const FormActions = ({ 
  onPreview, 
  isSubmitting,
  hasCalculatedNutrition
}: FormActionsProps) => {
  return (
    <div className="flex justify-end gap-4">
      <Button
        type="button"
        variant="outline"
        onClick={onPreview}
      >
        <Eye className="w-4 h-4 mr-2" />
        Preview
      </Button>
      <Button type="submit" disabled={isSubmitting}>
        {isSubmitting ? (
          <>
            <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin mr-2" />
            Publishing...
          </>
        ) : (
          <>
            <Save className="w-4 h-4 mr-2" />
            Publish Recipe
          </>
        )}
      </Button>
    </div>
  );
};
